'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_FOOTER_CLASSNAME = exports.FULLPAGE_CLASSNAME = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FULLPAGE_CLASSNAME = exports.FULLPAGE_CLASSNAME = 'body--fullpage sticky--fullpage';
var NO_FOOTER_CLASSNAME = exports.NO_FOOTER_CLASSNAME = 'body--no-footer';

exports.default = function (Component) {
  return function (props) {
    return _react2.default.createElement(
      _reactBodyClassname2.default,
      { className: FULLPAGE_CLASSNAME },
      _react2.default.createElement(Component, props)
    );
  };
};